module.exports = __webpack_public_path__ + "img/greaterThan.91e22f7a.svg";